import { DateAndValue, EquipmentFilter } from "../types";
import { RopPortfolioSSEData } from "./portfolio.model";
import { RopAlarmSSEData } from "./alarm.model";
import { TrackerValue } from "../components/TrackerChart";
import { PlantaUGAtMinutes } from "../components/SunBurstChart";
import { getNumberOfUgName } from "../../usinas/ugsMapper";

// TODO: Rever os nomes, pois esses dados estão relacionados aos eventos do SSE
export enum EnumRopCards {
  RopCard01PrRealizado = 1,
  RopCard02PerformanceRatio = 2,
  RopCard03EnergiaGerada = 3,
  RopCard04ValorGerado = 4,
  RopCard05Disponibilidade = 5,
  RopCard06EstacaoSolarimetrica = 6,
  RopCard07GraficoEvolucaoChart = 7,
  // RopCard08EnergiaGeradaChart = 8, // Esse evento não existe, virou o RopCard13EnergiaPorEquipamento
  RopCard09EnergiaAcumulada = 9,
  RopCard10DiagramaDePerdas = 10,
  RopCard11EnergiaAcumuladaXEnergiaCertificada = 11,
  RopCard12Produtividade = 12,
  RopCard13EnergiaPorEquipamento = 13,
  // PortfolioSSEData = 14,
  RopCard15Pareto = 15,
  AlarmesAtivos = 16,
  RopCard17TensaoDeLinha = 17,
  RopCard18Tracker = 18,
  RopCard19Heatmap = 19,
  RopCard20PotenciaAtiva = 20,
  RopCard21EnergiaAcumulada = 21,

  //
  // Cartões Agregados
  //

  RopCard1002PerformanceRatioAggregated = 1002,
  RopCard1003EnergiaGeradaAggregated = 1003,
  RopCard1005DisponibilidadeAggregated = 1005,
  RopCard1020PotenciaAtivaAggregated = 1020,

  //
  // Cartões Derivados
  //

  RopCard2001PerformanceDosAtivos = 2001,

  //
  // Cartões "Container"
  //

  RopCard3001CentroDeOperacoesSolarPerformanceDosAtivos = 3001,
  RopCard3002CentroDeOperacoesSolarEventosDosAtivos = 3002,
  RopCard3003LiveSingleLineDiagram = 3003,
}

export type RopCardBase = {
  type: EnumRopCards;
  title: string;
  errorAsJson: string;
};

export type ValueAndDateTime = {
  dateTime: string;
  value: number;
};

export type RopCard01PrRealizadoRopCard = {
  type: EnumRopCards.RopCard01PrRealizado;
  title: string;
  value: number;
  errorAsJson: string;
};

export type RopCard02PerformanceRatioRopCard = {
  type: EnumRopCards.RopCard02PerformanceRatio;
  title: string;
  value: number;
  prPrevisto: number;
  errorAsJson: string;
};

export type RopCard03EnergiaGeradaRopCard = {
  type: EnumRopCards.RopCard03EnergiaGerada;
  title: string;
  planta: PlantaDataEnergiaGerada;
  errorAsJson: string;
};

export type RopCard04ValorGeradoRopCard = {
  type: EnumRopCards.RopCard04ValorGerado;
  title: string;
  planta: PlantaDataValorGerado;
  errorAsJson: string;
};

export type RopCard05DisponibilidadeRopCard = {
  type: EnumRopCards.RopCard05Disponibilidade;
  title: string;
  planta: PlantaDataDisponibilidade;
  errorAsJson: string;
};

export type RopCard06EstacaoSolarimetricaInfoRopCard = {
  type: EnumRopCards.RopCard06EstacaoSolarimetrica;
  estacaoSolimetrica: {
    potenciaAtiva: BaseUsinaValue;
    irradiacaoInclinada: BaseUsinaValue;
    temperaturaAmbiente: BaseUsinaValue;
    temperaturaModulo: BaseUsinaValue;
    umidadeRelativa: BaseUsinaValue;
    velocidadeVento: BaseUsinaValue;
  };
  dataHoraCaptura: string;
  errorAsJson: string;
};

export type RopCard07GraficoEvolucaoChartRopCard = {
  type: EnumRopCards.RopCard07GraficoEvolucaoChart;
  title: string;
  lastUpdate: Date;
  dateReference: string;
  planta: PlantaDataEvolucao;
  errorAsJson: string;
};

// Esse evento não existe, virou o RopCard13EnergiaPorEquipamento
// export type RopCard08EnergiaGeradaChartRopCard = {
//   type: EnumRopCards.RopCard08EnergiaGeradaChart;
//   title: string;
//   planta: number;
//   unidadeGeneradora: number;
//   unidadeInversora: number;
//   stringBox: number;
// };

export type RopCard09EnergiaAcumuladaRopCard = {
  type: EnumRopCards.RopCard09EnergiaAcumulada;
  title: string;
  energiaIdealAcumulada: ValueAndDateTime[];
  energiaGeradaAcumulada: ValueAndDateTime[];
  p50Acumulada: ValueAndDateTime[];
  chartDateBrasilia?: string;
  p50AcumuladoDaily: number;
  p50AcumuladoHourly: number;
  errorAsJson: string;
};

export type RopCard10DiagramaDePerdasRopCard = {
  type: EnumRopCards.RopCard10DiagramaDePerdas;
  title: string;
  energiaLadoCC: number;
  energiaLadoCA: number;
  energiaLadoSE: number;
  energiaGerada: number;
  energiaIdeal: number;
  perdaNoCircuito: number;
  perdaDosInversores: number;
  perdaDoTrafo: number;
  perdaPorIndisponibilidade: number;
  outrasPerdas: number;
  lastCollectTime: string;
  errorAsJson: string;
};

export type RopCard11EnergiaAcumuladaXEnergiaCertificadaRopCard = {
  type: EnumRopCards.RopCard11EnergiaAcumuladaXEnergiaCertificada;
  title: string;

  generatedEnergy: ValueAndDateTime[];

  energiaCertificadaP50Months: ValueAndDateTime[];
  energiaCertificadaP75Months: ValueAndDateTime[];
  energiaCertificadaP90Months: ValueAndDateTime[];
  energiaCertificadaP95Months: ValueAndDateTime[];

  energiaCertificadaP50Daily: number;
  energiaCertificadaP75Daily: number;
  energiaCertificadaP90Daily: number;
  energiaCertificadaP95Daily: number;

  energiaCertificadaP50Hourly: number;
  energiaCertificadaP75Hourly: number;
  energiaCertificadaP90Hourly: number;
  energiaCertificadaP95Hourly: number;

  energiaCertificadaP50NormalizedValues: DateAndValue[];
  energiaCertificadaP75NormalizedValues: DateAndValue[];
  energiaCertificadaP90NormalizedValues: DateAndValue[];
  energiaCertificadaP95NormalizedValues: DateAndValue[];

  errorAsJson: string;
};

export type RopCard12ProdutividadeRopCard = {
  type: EnumRopCards.RopCard12Produtividade;
  title: string;
  generatedEnergy: BaseUsinaValue[];
  predictedEnergy: BaseUsinaValue[];
  irradiance: BaseUsinaValue[];
  predictedIrradianceMonths: BaseUsinaValue[];
  expectedEnergyAtDay: number;
  expectedEnergyAtHour: number;
  expectedIrradianciaAtDay: number;
  expectedIrradianciaAtHour: number;
  expectedIrradianciaNormalizedAtHour: BaseUsinaValue[];
  expectedEnergyNormalizedAtHour: BaseUsinaValue[];
  errorAsJson: string;
};

export type RopCard13EnergiaPorEquipamentoRopCard = {
  type: EnumRopCards.RopCard13EnergiaPorEquipamento;
  title: string;
  planta: PlantaDataExplosaoSolar;
  plantaMinutes: PlantaMinutes;
  errorAsJson: string;
};

export type RopCard15ParetoRopCard = {
  type: EnumRopCards.RopCard15Pareto;
  title: string;
  alarms: Array<{
    code: string;
    amount: number;
    percentage: number;
    name: string;
  }>;
  errorAsJson: string;
};

export type RopCard17TensaoDeLinhaRopCard = {
  type: EnumRopCards.RopCard17TensaoDeLinha;
  title: string;
  tensaoDeLinhakV: number;
  errorAsJson: string;
};
export type RopCard18TrackerRopCard = {
  type: EnumRopCards.RopCard18Tracker;
  title: string;
  expectedAngle: number;
  trackers: TrackerValue[];
  errorAsJson: string;
};

export type RopCard19HeatmapRopCard = {
  type: EnumRopCards.RopCard19Heatmap;
  title: string;
  inversores: AggregatedInversor[];
  errorAsJson: string;
};

export type RopCard20PotenciaAtivaRopCard = {
  type: EnumRopCards.RopCard20PotenciaAtiva;
  title: string;
  potenciaAtiva?: BaseUsinaValue;
  errorAsJson?: string;
};

export type RopCard21EnergiaAcumuladaRopCard = {
  type: EnumRopCards.RopCard21EnergiaAcumulada;
  title: string;
  energiaAcumulada?: BaseUsinaValue;
  errorAsJson?: string;
};

export type RopCard =
  | RopCard01PrRealizadoRopCard
  | RopCard02PerformanceRatioRopCard
  | RopCard03EnergiaGeradaRopCard
  | RopCard04ValorGeradoRopCard
  | RopCard05DisponibilidadeRopCard
  | RopCard06EstacaoSolarimetricaInfoRopCard
  | RopCard07GraficoEvolucaoChartRopCard
  // | RopCard08EnergiaGeradaChartRopCard // Esse evento não existe, virou o RopCard13EnergiaPorEquipamento
  | RopCard09EnergiaAcumuladaRopCard
  | RopCard10DiagramaDePerdasRopCard
  | RopCard11EnergiaAcumuladaXEnergiaCertificadaRopCard
  | RopCard12ProdutividadeRopCard
  | RopCard13EnergiaPorEquipamentoRopCard
  | RopPortfolioSSEData
  | RopAlarmSSEData
  | RopCard15ParetoRopCard
  | RopCard17TensaoDeLinhaRopCard
  | RopCard18TrackerRopCard
  | RopCard19HeatmapRopCard
  | RopCard20PotenciaAtivaRopCard
  | RopCard21EnergiaAcumuladaRopCard;

export type Period = {
  start?: string;
  end?: string;
  startDateOnly?: string;
  endDateOnly?: string;
};

export type BaseErrorCard = {
  Code?: number;
  InnerException?: unknown;
  Message?: string;
};

export type BaseUsinaValue = {
  dateTime?: string;
  value?: number;
  usinaId?: number;
  period?: Period;
  collectedAt?: string;
  errorAsJson?: string;
};

export type BaseUsinaStringValue = {
  dateTime?: string;
  value?: string;
  usinaId?: number;
  period?: Period;
  collectedAt?: string;
  errorAsJson?: string;
};

export type AggregatedInversor = Omit<BaseUsinaValue, "dateTime" | "value"> & {
  name?: string;
  potenciaAtivaAtMinutes?: BaseUsinaValue[];
};

type PlantaMinutes = {
  name?: string;
  uGs?: PlantaUGAtMinutes[];
  potenciaAtivaAtMinutes?: BaseUsinaValue[];
  lastPotenciaAtivaMinute?: number;
  usinaName: string;
  usinaId: number;
  period: Period;
  collectedAt: string;
  errors: any[];
  energiaGerada?: number;
  potenciaAtiva?: number;
};

export type PlantaDataEnergiaGerada = {
  values: {
    gerada: BaseUsinaValue;
    prevista: BaseUsinaValue;
    previstaPercentual: BaseUsinaValue;
  };
  uGs: {
    name: string;
    values: {
      gerada: BaseUsinaValue;
      prevista: BaseUsinaValue;
      previstaPercentual: BaseUsinaValue;
    };
    inversores: {
      name: string;
      values: {
        gerada: BaseUsinaValue;
        prevista: BaseUsinaValue;
        previstaPercentual: BaseUsinaValue;
      };
    }[];
  }[];
};

export type PlantaDataValorGerado = {
  values: {
    gerado: BaseUsinaValue;
    previsto: BaseUsinaValue;
    previstoPercentual: BaseUsinaValue;
  };
  uGs: {
    name: string;
    values: {
      gerado: BaseUsinaValue;
      previsto: BaseUsinaValue;
      previstoPercentual: BaseUsinaValue;
    };
    inversores: {
      name: string;
      values: {
        gerado: BaseUsinaValue;
        previsto: BaseUsinaValue;
        previstoPercentual: BaseUsinaValue;
      };
    }[];
  }[];
};

export type PlantaDataDisponibilidade = {
  values: {
    value: BaseUsinaValue;
    hourlyValues: BaseUsinaValue[];
  };
  uGs: {
    name: string;
    values: {
      value: BaseUsinaValue;
      hourlyValues: BaseUsinaValue[];
    };
    inversores: {
      name: string;
      values: {
        value: BaseUsinaValue;
        hourlyValues: BaseUsinaValue[];
      };
    }[];
  }[];
};

export type PlantaDataEvolucao = {
  values: {
    evolution: ValueAndDateTime[];
    irradiancia: ValueAndDateTime[];
    potenciaAtivaAtMinutes: ValueAndDateTime[];
    irradianciaMediaAtMinutes: ValueAndDateTime[];
  };
  uGs: {
    name: string;
    values: {
      evolution: ValueAndDateTime[];
      potenciaAtivaAtMinutes: ValueAndDateTime[];
    };
    inversores: {
      name: string;
      values: {
        evolution: ValueAndDateTime[];
        potenciaAtivaAtMinutes: ValueAndDateTime[];
      };
    }[];
  }[];
};

export type PlantaDataExplosaoSolar = Omit<PlantaData, "uGs"> & {
  energiaGerada?: BaseUsinaValue;
  potenciaAtiva?: BaseUsinaValue;
  uGs: PlantaUG[];
};

export type PlantaData = Area & {
  lastCollectTime?: string;
  uGs: PlantaUG[];
  period: Period;
  collectedAt: string;
  errors: any[];
};

export type PlantaInversor = Area;

export type PlantaUG = Area & {
  inversores?: PlantaInversor[];
};

export type Area = {
  name: string;
  usinaName: string;
  usinaId: number;
};

export function getSelectedArea(
  data: any,
  equipmentFilter: EquipmentFilter
): Area {
  if (!equipmentFilter.inversorName && !equipmentFilter.ugName) {
    return data;
  }
  const filterUgNumber = getNumberOfUgName(equipmentFilter.ugName);
  const filteredUg = data?.uGs?.find((ug: any) => {
    if (ug.name == equipmentFilter.ugName) return true;
    if (filterUgNumber === undefined) return false;
    return getNumberOfUgName(ug.name) === filterUgNumber;
  });
  if (equipmentFilter.ugName && !equipmentFilter.inversorName && filteredUg) {
    return filteredUg;
  }
  const filteredInv = filteredUg?.inversores?.find(
    (inversor: any) => inversor.name === equipmentFilter.inversorName
  );
  if (equipmentFilter.inversorName && equipmentFilter.ugName && filteredInv) {
    return filteredInv;
  }
  return data;
}
